import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d0bd5c0a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=d0bd5c0a&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=d0bd5c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bd5c0a",
  null
  
)

export default component.exports